import * as types from './types'
import { combineReducers } from 'redux'
import { objectReducer, arrayReducer } from 'utils'

const account = combineReducers({
  main: objectReducer(types.FETCH_ACCOUNT, {}),

  notifications: arrayReducer(types.FETCH_NOTIFICATION_SETTINGS, [], data => data.subscriptions),

  subscriptions: arrayReducer(types.FETCH_SUBSCRIPTIONS, [], data => data.data),

  deleted: (state = false, { type }) => type == types.DELETE_ACCOUNT_SUCCESS || state,

  intro: (state = false, { type }) => (/INTRO_/.test(type) ? type == types.INTRO_START : state),

  registration: (state = { notLoaded: true, data: {} }, { type, payload, error }) => {
    const { data } = state

    switch (type) {
      case types.FETCH_CONFIRMATION_SUCCESS:
        return payload.data ? { data: payload.data } : { complete: true, data } // 204 empty means already completed

      case types.CONFIRM_REGISTRATION_SUCCESS:
        return { complete: true, data }

      case types.FETCH_CONFIRMATION_ERROR:
      case types.CONFIRM_REGISTRATION_ERROR:
        return error.location ? { data, complete: true, ...error } : { data, ...error }

      default:
        return state
    }
  },

  helpForm: objectReducer(types.SUBMIT_HELP_FORM),
})

export default account
